export type { CodeInlineProps } from './code-inline';
export { default } from './code-inline';
